
import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/auth";
import { supabase } from "@/integrations/supabase/client";
import { VerificationHistoryTable } from "./history/VerificationHistoryTable";
import { DocumentPreviewDialog } from "./identity-verification/DocumentPreviewDialog";
import { VerificationStatusCard } from "./identity-verification/VerificationStatusCard";
import { DocumentsList } from "./identity-verification/DocumentsList";

export default function IdentityVerificationForm() {
  const { profile } = useAuth();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDocumentPreview, setShowDocumentPreview] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  // Fetch user's verification documents
  useEffect(() => {
    const fetchDocuments = async () => {
      if (!profile?.id) return;

      setLoading(true);

      try {
        const { data, error } = await supabase
          .from("user_id_documents")
          .select(
            `
            *,
            id_document_types (
              document_name,
              country_code
            )
          `
          )
          .eq("user_id", profile.id);

        if (error) throw error;

        setDocuments(data || []);
      } catch (error) {
        console.error("Error fetching user documents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, [profile?.id]);

  const handleViewDocument = async (document) => {
    setSelectedDocument(document);
    setShowDocumentPreview(true);
  };

  const hasVerifiedDocuments = documents.some(
    (doc) => doc.verification_status === "verified"
  );

  let verifiedCountries: string[] = [];
  if (profile?.verified_countries) {
    if (Array.isArray(profile.verified_countries)) {
      verifiedCountries = profile.verified_countries.map((country) =>
        String(country)
      );
    } else if (typeof profile.verified_countries === "object") {
      try {
        const jsonValues = Object.values(profile.verified_countries);
        verifiedCountries = jsonValues.map((val) => String(val));
      } catch (e) {
        console.error("Error parsing verified_countries:", e);
        verifiedCountries = [];
      }
    }
  }

  return (
    <>
      <VerificationStatusCard
        profile={profile}
        documents={documents}
        loading={loading}
        verifiedCountries={verifiedCountries}
        hasVerifiedDocuments={hasVerifiedDocuments}
      />

      <DocumentsList
        documents={documents}
        loading={loading}
        onViewDocument={handleViewDocument}
      />

      <div className="mt-8">
        <VerificationHistoryTable />
      </div>

      <DocumentPreviewDialog
        open={showDocumentPreview}
        onOpenChange={setShowDocumentPreview}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
